import(/* webpackMode: "eager", webpackExports: ["BottomNavLayout"] */ "/codebuild/output/src44592004/src/smart-consumption-web/src/components/bottom-nav-layout.tsx");
